import styled from 'styled-components';

import { media } from '../../utils/mediaQueries';

export const FileCardWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    padding: 10px 12px;
    background: ${({ theme }) => (theme.mode === 'dark' ? '#242a33' : '#ffffff')};
    border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#dcdfe4')};
    border-radius: 10px;
    gap: 12px;
    width: auto;
    max-width: min(420px, 100%);
    min-width: 0;
    min-height: 54px;
    box-sizing: border-box;
    margin-inline: auto;
    transition: all 0.2s ease;

    &:hover {
        background: ${({ theme }) => (theme.mode === 'dark' ? '#2c333d' : '#f9fafb')};
        border-color: ${({ theme }) => (theme.mode === 'dark' ? '#4b5563' : '#d1d5db')};
    }

    ${media.mobile} {
        max-width: 100%;
        padding: 10px;
        gap: 8px;
    }
`;

export const FilenameBox = styled.div`
    position: relative;
    flex: 1;
    min-width: 0;
    max-width: 200px;
    overflow: hidden;

    ${media.mobile} {
        max-width: none;
    }
`;

export const FilenameEllipsis = styled.span`
    display: block;
    font-size: 13px;
    color: ${({ theme }) => (theme.mode === 'dark' ? '#d1d5db' : '#374151')};
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 300px;

    ${media.mobile} {
        font-size: 12px;
        max-width: none;
    }
`;

/* Większa, ostra miniatura obrazu — wzorowana na podglądzie produktu (Outlets):
   object-fit: cover, tło zastępcze, zaokrąglenie i ramka. */
export const ImageThumbnail = styled.div<{ $imageUrl: string }>`
    width: 48px;
    height: 48px;
    border-radius: 8px;
    background-color: ${({ theme }) => (theme.mode === 'dark' ? '#242a33' : '#f3f4f6')};
    background-image: url('${({ $imageUrl }) => $imageUrl}');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    flex-shrink: 0;
    border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#dcdfe4')};
`;

export const PreviewPopover = styled.div`
    position: absolute;
    bottom: calc(100% + 10px);
    left: 50%;
    transform: translateX(-50%);
    width: 280px;
    height: 280px;
    background: ${({ theme }) => (theme.mode === 'dark' ? '#242a33' : 'white')};
    border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : 'transparent')};
    border-radius: 6px;
    box-shadow: ${({ theme }) => (theme.mode === 'dark' ? '0 20px 40px rgba(0, 0, 0, 0.4)' : '0 20px 40px rgba(0, 0, 0, 0.15)')};
    padding: 8px;
    z-index: 9999;
    pointer-events: none;
    animation: fadeIn 0.2s ease;

    /* Arrow */
    &::after {
        content: '';
        position: absolute;
        bottom: -8px;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-top: 8px solid ${({ theme }) => (theme.mode === 'dark' ? '#242a33' : 'white')};
        filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translateX(-50%) translateY(-5px);
        }
        to {
            opacity: 1;
            transform: translateX(-50%) translateY(0);
        }
    }

    /* Responsive dla małych ekranów */
    @media (max-width: 768px) {
        width: 200px;
        height: 200px;
    }
`;

export const FlagWrapper = styled.div`
    position: relative;
    width: auto;
    height: 30px;
    z-index: 100;
    overflow: hidden;
    top: 2px;
`;

export const Flag = styled.img`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 10px;
    width: 15px;
`;
